import { render } from "./WorkEnvironment.vue?vue&type=template&id=4d24ed62&scoped=true&ts=true"
import script from "./WorkEnvironment.vue?vue&type=script&lang=ts"
export * from "./WorkEnvironment.vue?vue&type=script&lang=ts"

import "./WorkEnvironment.vue?vue&type=style&index=0&id=4d24ed62&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d24ed62"]])

export default __exports__